// Third party
import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Components
import { IRootState } from './type';
import { reducers } from './reducers';
import { TAssignment } from '../../types';
import { PERSIST_KEYS, STORE_SLICES } from '../../utils';

const initialState: IRootState = {
  assignments: {} as TAssignment,
};

export const slice = createSlice({
  name: STORE_SLICES.ASSIGNMENT_DATA,
  initialState,
  reducers,
});

const assignmentDataActions = slice.actions;

const assignmentDataPersistConfig = {
  key: PERSIST_KEYS.ASSIGNMENT_DATA,
  storage,
  whitelist: ['assignments'],
};

export { assignmentDataActions, initialState };
export default persistReducer(assignmentDataPersistConfig, slice.reducer);
